






import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'adb-tabs',
})
export default class extends Vue {}
